import Filter from './filter';

const VISIBILITY_DATASET_NAME = 'visibility';

export default class FilterPool {
    constructor(targets) {
        this.targets = targets;
        this.filters = [];

        this.targets.filter(target => document.body.contains(target));
        this.targets.forEach(target => target.dataset[VISIBILITY_DATASET_NAME] = true);
    }

    registerFilter(filter) {
        return (filter instanceof Filter) ? this.filters.push(filter) : false;
    }

    update() {
        this.targets.forEach((target) => {
            // Checks if the target matches any filter and sets the visibility accordingly
            target.dataset[VISIBILITY_DATASET_NAME] = this.filters.every(filter => filter.test(target));
        });
    }
}